import OutboundEnhancedTableHead from './OutboundEnhancedTableHead.view';

export default OutboundEnhancedTableHead;
